import Select, {components} from 'react-select'
import React, {useEffect, useMemo, useState} from 'react'
import {Modal, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import CreatableSelect from 'react-select/creatable'
import {useDispatch, useSelector} from 'react-redux'
import {OptionName} from '../Constant/SelectOption'
import AddTagToSubscriber from './AddTagToSubscriber'
import {
  CreateDataPost,
  CreateData as subscriberCreate,
} from '../../AllContactsList/SubscriberSlice/SubscriberSlice'
import {ContactOpenPopup, ContactStartUpload} from '../../../../../Components/PopupSlice/popupSlice'
import FieldPopupModel from './FieldPopupModel'
import ReviewModal from './ReviewModal'
import {usePutUploadContactsMutation} from '../../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {toString} from 'lodash'
import {validatePhoneNumberRegionWithMessage} from '../../../../../Utils/_helpers'
import {getDefaultRegion} from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const MappingSubscriberList = ({
  show,
  handleClose,
  data,
  setMapped,
  mapped,
  finalData,
  setFinalData,
  closeUpload,
  resubscribe,
  setCheckbox,
  setCsvdata,
  selectedTag,
  setSelectedTag,
}: any) => {
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)
  const [addTags, setAddTags] = useState(false)
  const dispatch = useDispatch()
  const [error, setError] = useState('')
  const dbOptions: any[] =
    useSelector((state: any) => state?.subscriberData?.FieldName?.data?.fields) || []
  //////////////////////////////////////ALL NEW USESTATE////////////////////////
  const [selectedOption, setSeletedOption] = useState<any>([])
  const [totalSelectedOption, setTotalSelectedOption] = useState<any>([])
  const [totalOptions, setTotalOptions] = useState<any>([])
  const [newCreateBol, setNewCreateBol] = useState(true)
  const [fieldModel, setFieldModel] = useState(false)
  const [disabledOption, setDisableOption] = useState<any>([])
  const [totalOption, setTotalOption] = useState<any>(OptionName)
  const [selectedData, setSelectedData] = useState<any>([])
  const [selectedField, setSelectedField] = useState<any>({
    inde: 0,
    name: '',
  })
  const userRegion = useSelector(getDefaultRegion)

  const [reviewModal, setReviewModal] = useState(false)
  ////////////////////////////////////New useEffect///////////////////////////////////
  ////First to set To
  const capitalizeFirstLetter = (str: any) => {
    const words = str.split(' ')

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1)
    }

    return words.join(' ')
  }

  const [uploadContactsV2, resultUploadContacts] = usePutUploadContactsMutation()

  useEffect(() => {
    let arrayOfOption: any = []
    let mappedDataAuto: any = []
    let selected: any = []
    data?.[0]?.map((val: any, index: number) => {
      const sampleData = data?.length > 1 ? data[1] : []
      const checkNumberIndex = sampleData[index]

      const validateNumber = validatePhoneNumberRegionWithMessage({
        number: checkNumberIndex,
        region: userRegion,
        validateDuplicate: false,
        contacts: new Map(),
      })
      if (validateNumber.isValid) {
        const checkIsNumberIndex = sampleData.findIndex(
          (it: string) =>
            validatePhoneNumberRegionWithMessage({
              number: it,
              region: userRegion,
              validateDuplicate: false,
              contacts: new Map(),
            }).isValid
        )

        if (checkIsNumberIndex === index) {
          arrayOfOption?.push({value: 'mobile number', index: index})
          mappedDataAuto?.push({oldLabel: val, newLabel: 'mobile number'})
        }
      }
      let autoSelectedOption = totalOption?.find(
        (key: any) =>
          key?.value?.replace(/\s/g, '')?.toLowerCase() === val?.replace(/\s/g, '')?.toLowerCase()
      )
      if (autoSelectedOption) {
        arrayOfOption?.push({value: autoSelectedOption?.value, index: index})
        mappedDataAuto?.push({oldLabel: val, newLabel: autoSelectedOption.value})
        selected?.push({...autoSelectedOption, index})
      }
    })

    // only do auto mapp when show match data modal open
    if (show) {
      setDisableOption([...disabledOption, ...arrayOfOption])
      setMapped(mappedDataAuto)
      setSeletedOption(selected)
    }
  }, [show])
  // useEffect(() => {}, [dbOptions, show])

  const findOptionLabel = (selected: string) => {
    return OptionName.find((data) => data.value === selected)?.label
  }

  useEffect(() => {
    if (dbOptions !== undefined) {
      let defaultOptions = OptionName?.map((val: any) => val.value)
      let newOptions = [...dbOptions, ...defaultOptions]
      let unique = newOptions
        .filter((item, i, ar) => ar.indexOf(item) === i)
        ?.map((val: any) => ({value: val, label: findOptionLabel(val) ?? val}))

      unique?.length > 30 && setNewCreateBol(false)
      setTotalOption(unique)
      setTotalSelectedOption(dbOptions)
      setTotalOptions(unique)
    }
  }, [show])

  //////////////////////////////////////NEW LOGIC FOR HANDLE SELECT//////////////////////
  const handleSelect = (selectedValue: any, index: number) => {
    //validation birthday
    if (['Birthday', 'birthday'].includes(selectedValue?.value)) {
      let normalDateParts = []
      const birthday = toString(data?.at(1)?.at(index))
      if (birthday?.includes('-')) normalDateParts = birthday.split('-')

      if (!normalDateParts.length) {
        setError('Wrong birthday format it should have this format 25-03-2000')
        return
      }
    } else {
      setError('')
    }

    // Function to remove the selected option
    const removeSelectedOption = (value: string) => {
      const updatedDisabledOptions = disabledOption.filter((option: any) => option.index !== index)
      setDisableOption(updatedDisabledOptions)

      const indexOfMapped = mapped.findIndex((item: any) => item.newLabel === value)
      if (indexOfMapped !== -1) {
        mapped.splice(indexOfMapped, 1)
        setMapped([...mapped])

        if (dbOptions && !dbOptions.includes(value)) {
          const updatedTotalSelectedOption = totalSelectedOption.filter(
            (item: any) => item !== value
          )
          updatedTotalSelectedOption?.length == 18 && setNewCreateBol(false)
          setTotalSelectedOption(updatedTotalSelectedOption)
        }
      }

      // if (!OptionName?.map((val: any) => val.value).includes(value)) {
      //   let tempTotal = totalOptions ?? []
      //   tempTotal = tempTotal.filter((data: any) => data?.value != value)
      //   setTotalOptions(tempTotal)
      // }

      let tempData = selectedData ?? []
      // tempData = tempData.filter((data: any) => data?.value != value)

      tempData[index] = null

      setSelectedData(tempData)
    }

    if (!selectedValue) {
      const nameOfRemoveOption = disabledOption.find((val: any) => val.index === index)?.value

      if (nameOfRemoveOption) {
        removeSelectedOption(nameOfRemoveOption)
      }
    } else {
      // Check if the selected option is already disabled
      const isOptionDisabled = disabledOption.find((option: any) => option.index === index)

      // If it's disabled, update it; otherwise, add it to disabled options
      if (isOptionDisabled) {
        const updatedDisabledOptions = disabledOption.map((option: any) =>
          option.index === index ? {value: selectedValue.value, index} : option
        )
        setDisableOption(updatedDisabledOptions)
      } else {
        setDisableOption([...disabledOption, {value: selectedValue.value, index}])
      }

      // Add the selected option to totalSelected if it's not already there
      if (!totalSelectedOption.includes(selectedValue.value)) {
        setTotalSelectedOption([...totalSelectedOption, selectedValue.value])
      }

      // Map oldLabel and newLabel and store it
      const indexOfMappedOldLabel = mapped.findIndex(
        (item: any) => item.oldLabel === data[0][index]
      )

      if (indexOfMappedOldLabel === -1) {
        if (selectedValue.value === 'mobile number') {
          setMapped([...mapped, {oldLabel: data[0][index], newLabel: 'mobile number'}])
        } else {
          setMapped([...mapped, {oldLabel: data[0][index], newLabel: selectedValue.value}])
        }
      } else {
        // Remove and update the disabled option
        const indexOfDisabledOption = disabledOption.findIndex(
          (option: any) => option.index === index
        )
        disabledOption.splice(indexOfDisabledOption, 1)
        setDisableOption([...disabledOption, {value: selectedValue.value, index}])

        // Update oldLabel mapped data with newLabel data
        mapped.splice(indexOfMappedOldLabel, 1)
        setMapped([...mapped, {oldLabel: data[0][index], newLabel: selectedValue.value}])
      }
      let tempData = selectedData ?? []
      tempData[index] = {value: selectedValue.value, label: selectedValue.value}
      setSelectedData(tempData)

      let tempOptionsData = totalOptions ?? []

      if (!tempOptionsData?.some((data: {value: string}) => data?.value == selectedValue.value)) {
        tempOptionsData = [
          ...tempOptionsData,
          {value: selectedValue.value, label: selectedValue.value},
        ]
      }

      if (tempOptionsData?.length > 17) setNewCreateBol(false)
      setTotalOptions(tempOptionsData)
    }
  }

  ////////////////////////////////////ALL USE MEMO/////////////////////////////////////////////
  const addTag = useMemo(
    () => (
      <AddTagToSubscriber
        data={data}
        mapped={mapped}
        setMapped={setMapped}
        setFinalData={setFinalData}
        finalData={finalData}
        show={addTags}
        handleClose={() => setAddTags(false)}
        close={handleClose}
        setDisableoption={setDisableOption}
        setFieldName={setTotalOption}
        closeUpload={closeUpload}
      />
    ),
    [addTags]
  )

  const onCancle = () => {
    setTotalOption(OptionName)
    handleClose()
    setMapped([])
    setDisableOption([])
    setCheckbox(false)
    setSelectedTag([])
    setCsvdata([])
    setFinalData({
      name: '',
      file: '',
      mergeLabels: '',
      tagIds: '',
      unSubList: finalData?.unSubList,
    })
    setError('')
  }
  const handleSubmitReview = async () => {
    let data1 = new FormData()
    let Findids = tagslist
      ?.map((val: any) => {
        if (selectedTag?.find((key: any) => key?.label == val?.name) !== undefined) {
          return val?._id
        }
      })
      ?.filter((key: any) => key !== undefined)

    let ff: any = {
      name: finalData?.name,
      unSubList: finalData?.unSubList,
      file: finalData?.file,
      mergeLabels: JSON.stringify(mapped),
      tagIds: JSON.stringify([...Findids]),
      validate: true,
    }
    for (var key in ff) {
      data1.append(key, ff[key])
    }

    await uploadContactsV2({
      data: data1,
      id: groupid,
    }).then((result: any) => {
      handleClose()
      setReviewModal(true)
      toast.success(result?.data?.message)
    })
  }

  const handleNext = () => {
    let data1 = new FormData()
    let Findids = tagslist
      ?.map((val: any) => {
        if (selectedTag?.find((key: any) => key?.label == val?.name) !== undefined) {
          return val?._id
        }
      })
      ?.filter((key: any) => key !== undefined)

    let ff: any = {
      name: finalData?.name,
      unSubList: finalData?.unSubList,
      file: finalData?.file,
      mergeLabels: JSON.stringify(mapped),
      tagIds: JSON.stringify([...Findids]),
      validate: false,
      resubscribe,
    }

    for (var key in ff) {
      data1.append(key, ff[key])
    }

    toast.success('upload in progress')
    setReviewModal(false)
    uploadContactsV2({data: data1, id: groupid})
      .unwrap()
      .then((it: any) => {
        toast.success(it?.data?.message)
      })
      .catch((e) => {
        toast.error('failed upload contacts')
      })
      .finally(() => {
        setReviewModal(false)
      })
    handleClose()
    setTotalOption(OptionName)

    setDisableOption([])
    setCheckbox(false)
    setCsvdata([])
    setFinalData({
      name: '',
      file: '',
      mergeLabels: '',
      tagIds: '',
      unSubList: finalData?.unSubList,
    })
    setAddTags(false)
    setMapped([])
    setSelectedTag([])
    closeUpload()
    dispatch(ContactOpenPopup())
  }

  const MenuListComponent = (props: any) => {
    const {index, newCreateBol, ...rest} = props
    return (
      <components.MenuList {...rest}>
        {props.children}
        <OverlayTrigger
          placement='top'
          overlay={<Tooltip id='button-tooltip'>Create new field</Tooltip>}
        >
          <div>
            {newCreateBol ? (
              <div
                className='select-create-button'
                onClick={() => {
                  setFieldModel(true)
                  setSelectedField({
                    index,
                  })
                }}
              >
                <i className='bi bi-plus-lg'></i>
                <p>Create new</p>
              </div>
            ) : null}
          </div>
        </OverlayTrigger>
      </components.MenuList>
    )
  }
  const fieldPopup = useMemo(
    () => (
      <FieldPopupModel
        show={fieldModel}
        handleClose={(name: any = {}) => {
          handleSelect(name, selectedField.index)
          setFieldModel(false)
        }}
      />
    ),
    [fieldModel]
  )

  const reviewModalPopup = useMemo(
    () => (
      <ReviewModal
        show={reviewModal}
        handleClose={() => setReviewModal(false)}
        handleSubmit={handleNext}
        report={resultUploadContacts}
      />
    ),
    [reviewModal, resultUploadContacts?.isLoading]
  )

  useEffect(() => {
    let tempData: any[] = []
    tempData = data?.at(0)?.map((val: any, index: number) => {
      /////Logic for auto select option
      return totalOption?.find((key: any) => {
        const validateNumber = validatePhoneNumberRegionWithMessage({
          number: data?.length > 1 ? data[1][index] : '',
          region: userRegion,
          validateDuplicate: false,
          contacts: new Map(),
        })

        if (validateNumber.isValid) {
          const checkIsNumberIndex = data[1].findIndex(
            (it: string) =>
              validatePhoneNumberRegionWithMessage({
                number: it,
                region: userRegion,
                validateDuplicate: false,
                contacts: new Map(),
              }).isValid
          )

          if (checkIsNumberIndex === index) {
            return key?.value?.replace(/\s/g, '')?.toLowerCase() === 'mobilenumber'
          }
          return false
        } else {
          let x =
            key?.value?.replace(/\s/g, '')?.toLowerCase() == val?.replace(/\s/g, '')?.toLowerCase()
          return x
        }
      })
    })
    setSelectedData(tempData)
  }, [data, totalOption])

  return (
    <>
      {addTag}
      <Modal
        dialogClassName='modal-dialog-centered mw-650px'
        show={show}
        onHide={() => {
          handleClose()
          setCsvdata([])
          setSelectedTag([])
          setCheckbox(false)
          setDisableOption([])
          setFinalData({
            name: '',
            file: '',
            mergeLabels: '',
            tagIds: '',
            unSubList: finalData?.unSubList,
          })
        }}
      >
        <div className='modal-header'>
          <h2>Match custom data</h2>
        </div>
        <div className='modal-body px-20'>
          {data?.[0]?.map((val: any, index1: number) => {
            let autoSelectedOption = totalOption?.find((key: any) => {
              if (
                /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/gm.test(
                  data[1][index1]
                )
              ) {
                const checkIsNumberIndex = data[1].findIndex((it: string) =>
                  /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/gm.test(
                    it
                  )
                )

                if (checkIsNumberIndex === index1) {
                  return key?.value?.replace(/\s/g, '')?.toLowerCase() == 'mobilenumber'
                }
                return false
              } else {
                let x =
                  key?.value?.replace(/\s/g, '')?.toLowerCase() ==
                  val?.replace(/\s/g, '')?.toLowerCase()
                return x
              }
            })

            return (
              <div className='row justify-content-start mb-5 mt-10 custome-fields' key={index1}>
                <div className='col-4'>
                  {data?.map(
                    (val: any, index2: number) =>
                      index2 < 4 && (
                        <React.Fragment key={index2}>
                          {index2 == 0 ? (
                            <>
                              {val?.map((key: any, index3: number) => (
                                <React.Fragment key={index3}>
                                  {index3 == index1 && (
                                    <h3
                                      className='fs-7'
                                      style={{
                                        color: '#232323',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      {key}
                                    </h3>
                                  )}
                                </React.Fragment>
                              ))}
                            </>
                          ) : (
                            <>
                              {val?.map((key: any, index4: number) => (
                                <React.Fragment key={index4}>
                                  {index4 == index1 && (
                                    <li
                                      className='list-unstyled fs-7'
                                      style={{
                                        color: '#A2A5B5',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      {key}
                                    </li>
                                  )}
                                </React.Fragment>
                              ))}
                            </>
                          )}
                        </React.Fragment>
                      )
                  )}
                </div>
                <div className='col-8'>
                  <label className='mb-2'>Select a field</label>
                  <Select
                    classNamePrefix='createBox'
                    className='select_create react-tags-fieldBox selectbox-create-custom'
                    components={{
                      MenuList: (props) => (
                        <MenuListComponent index={index1} newCreateBol={newCreateBol} {...props} />
                      ),
                    }}
                    onChange={(e: any) => {
                      handleSelect(e, index1)
                    }}
                    isOptionDisabled={(option: any) => {
                      let d = disabledOption.map((val: any) => val.value)

                      return d?.includes(option.value)
                    }}
                    value={selectedData?.[index1] ?? null}
                    defaultValue={autoSelectedOption}
                    options={totalOptions ?? []}
                    isClearable
                  />
                </div>
              </div>
            )
          })}
        </div>
        <span className='text-danger mx-15'>{error}</span>
        <div className='modal-footer w-100'>
          <button onClick={onCancle} type='button' className='btn btn-light-primary'>
            Cancel
          </button>
          <button
            disabled={
              error?.length > 0 ||
              resultUploadContacts?.isLoading ||
              !mapped?.map((val: any) => val?.newLabel)?.includes('mobile number')
            }
            onClick={handleSubmitReview}
            id='submit'
            type='button'
            className='btn btn-primary'
          >
            {resultUploadContacts?.isLoading ? (
              <div className='d-flex justify-content-center align-items-center'>
                <Spinner variant='primary' animation='grow' /> Loading....
              </div>
            ) : (
              'Review'
            )}
          </button>
        </div>
      </Modal>

      {fieldPopup}
      {reviewModalPopup}
    </>
  )
}

export default MappingSubscriberList
